import React from "react";

const Home = () => {
  return (
    <div className="page-container">
      <div className="homeView">
        <img className="home-photo" src="./photos/noah.jpg" alt="" />

        <p>Yo, what's up? I'm Noah!</p>
        <p>Come and take a look at my work!</p>
      </div>
    </div>
  );
};

export default Home;
